"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WaveDropContent from "@/components/waves/drops/WaveDropContent";
import WaveDropMetadata from "@/components/waves/drops/WaveDropMetadata";
import { useRouter } from "next/navigation";
import WaveDropReactions from "@/components/waves/drops/WaveDropReactions";
import { getDropIdentityProfile, getDropVisibleMetadata } from "@/components/waves/drops/identityDisplay.helpers";
import { areSameProfileIdentity } from "@/helpers/ProfileHelpers";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import { WaveLeaderboardIdentity } from "../identity/WaveLeaderboardIdentity";
interface WaveLeaderboardDropContentProps {
  readonly drop: ExtendedDrop;
  readonly isCompetitionDrop?: boolean | undefined;
}
export const WaveLeaderboardDropContent: React.FC<WaveLeaderboardDropContentProps> = t0 => {
  const $ = _c(26);
  const {
    drop,
    isCompetitionDrop: t1
  } = t0;
  const isCompetitionDrop = t1 === undefined ? false : t1;
  const router = useRouter();
  const [activePartIndex, setActivePartIndex] = useState(0);
  let t2;
  if ($[0] !== drop.metadata || $[1] !== drop.wave) {
    t2 = getDropVisibleMetadata({
      wave: drop.wave,
      metadata: drop.metadata
    });
    $[0] = drop.metadata;
    $[1] = drop.wave;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const visibleMetadata = t2;
  let t3;
  if ($[3] !== drop.author || $[4] !== drop.metadata || $[5] !== drop.wave) {
    const identityProfile = getDropIdentityProfile({
      wave: drop.wave,
      metadata: drop.metadata
    });
    t3 = identityProfile ? areSameProfileIdentity({
      left: drop.author,
      right: identityProfile
    }) : false;
    $[3] = drop.author;
    $[4] = drop.metadata;
    $[5] = drop.wave;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const isSelfNominee = t3;
  let t4;
  if ($[7] !== router) {
    t4 = clickedDrop => {
      const href = getWaveRoute({
        waveId: clickedDrop.wave.id,
        serialNo: clickedDrop.serial_no,
        isDirectMessage: false,
        isApp: false
      });
      router.push(href);
    };
    $[7] = router;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onDropContentClick = t4;
  let t5;
  if ($[9] !== activePartIndex || $[10] !== drop || $[11] !== isCompetitionDrop || $[12] !== onDropContentClick) {
    t5 = <WaveDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onDropContentClick={onDropContentClick} onLongPress={_temp} onQuoteClick={_temp2} setLongPressTriggered={_temp3} isCompetitionDrop={isCompetitionDrop} />;
    $[9] = activePartIndex;
    $[10] = drop;
    $[11] = isCompetitionDrop;
    $[12] = onDropContentClick;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = !isSelfNominee;
  let t7;
  if ($[14] !== drop || $[15] !== t6) {
    t7 = <WaveLeaderboardIdentity drop={drop} variant="responsive" cardVariant="chat" className="tw-mt-2 lg:tw-mt-0" showIdentityHeader={t6} />;
    $[14] = drop;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== visibleMetadata) {
    t8 = !!visibleMetadata.length && <WaveDropMetadata metadata={visibleMetadata} />;
    $[17] = visibleMetadata;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== drop) {
    t9 = <div className="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1"><WaveDropReactions drop={drop} /></div>;
    $[19] = drop;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t5 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
    t10 = <div className="-tw-mt-0.5 tw-flex tw-flex-col tw-gap-y-1">{t5}{t7}{t8}{t9}</div>;
    $[21] = t5;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
function _temp() {}
function _temp2() {}
function _temp3() {}